import { Dialog } from 'primereact/dialog';
import { useNavigate } from 'react-router-dom';
import React from 'react';
import { useDeleteOrganizationMutation } from '../../../api/organizations.js';
import lightning from '../../../resources/images/lightning.png';
import BaseButton from '../../form/BaseButton.jsx';
import IconCloseFull from '../../images/IconCloseFull.jsx';
import { useErrorToast } from '../../../hooks/useToast.jsx';

const OrganizationDeleteConfirmation = React.memo(({ deleteVisible, setDeleteVisible, organization }) => {
    const navigate = useNavigate();
    const [deleteOrganization, { isLoading: isDeleting }] = useDeleteOrganizationMutation();

    const hideDialog = () => {
        setDeleteVisible(false);
    };

    const confirmDelete = async () => {
        try {
            await deleteOrganization(organization.id).then((apiResponse) => {
                if (apiResponse.data?.success) {
                    navigate('/organizations/list');
                } else {
                    useErrorToast(apiResponse.data?.message);
                }
            });
        } catch (error) {
            console.error('Failed to delete organization:', error);
            useErrorToast('An unexpected error occurred while deleting the organization.');
        }

        setDeleteVisible(false);
    };

    if (!deleteVisible) return null;

    return (
        <Dialog
            className='rounded-4xl'
            visible={deleteVisible}
            style={{ width: '400px' }}
            breakpoints={{ '420px': '320px' }}
            onHide={hideDialog}
            content={() => (
                <div className='flex flex-col justify-center items-center px-6 py-8 pt-12 bg-white rounded-4xl'>
                    <button onClick={hideDialog} className='absolute top-6 right-6'>
                        <IconCloseFull className='fill-theme1-text5' />
                    </button>
                    <img alt='' src={lightning} className='w-[46px] h-[105px] mb-[16px]' />
                    <div className='text-theme1-primary text-[22px] mb-[30px] text-center leading-tight'>
                        Confirm Deleting Organization
                        <span className='font-bold block'>{organization.name}</span>
                    </div>
                    <div className='flex justify-between gap-4 w-full'>
                        <BaseButton
                            className='btn-red-outline w-[47%] flex-shrink-0'
                            textValue='Cancel'
                            onClick={hideDialog}
                        />

                        <BaseButton
                            className={`bg-theme1-primary text-white w-[47%] flex-shrink-0 ${isDeleting ? 'bg-theme1-text3' : ''}`}
                            textValue={isDeleting ? 'Deleting...' : 'Confirm'}
                            onClick={confirmDelete}
                            disabled={isDeleting}
                        />
                    </div>
                </div>
            )}
        ></Dialog>
    );
});

OrganizationDeleteConfirmation.displayName = 'OrganizationDeleteConfirmation';

export default OrganizationDeleteConfirmation;
